export default __webpack_public_path__ + "static/media/testimonials2.d22240c7.jpg";